import { render, staticRenderFns } from "./TransportationCoordinationList.vue?vue&type=template&id=6e7fbedc&scoped=true&"
import script from "./TransportationCoordinationList.vue?vue&type=script&lang=ts&"
export * from "./TransportationCoordinationList.vue?vue&type=script&lang=ts&"
import style0 from "./TransportationCoordinationList.vue?vue&type=style&index=0&id=6e7fbedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7fbedc",
  null
  
)

export default component.exports